import dynamic from 'next/dynamic';
import { BLOG_PAGE_TYPE } from '@/constants/blog';
import { valueof } from '@/types';

const TagBlogPage = dynamic(() => import('@/components/blog/pages/TagBlogPage'));
TagBlogPage.displayName = 'TagBlogPage';
const HomeBlogPage = dynamic(() => import('@/components/blog/pages/HomeBlogPage'));
HomeBlogPage.displayName = 'HomeBlogPage';
const CategBlogPage = dynamic(() => import('@/components/blog/pages/CategBlogPage'));
CategBlogPage.displayName = 'CategBlogPage';
const ArticleBlogPage = dynamic(() => import('@/components/blog/pages/ArticleBlogPage'));
ArticleBlogPage.displayName = 'ArticleBlogPage';

type BlogComponentProps = {
	data: any;
	componentType: valueof<typeof BLOG_PAGE_TYPE>;
};

export const BlogComponent = ({ data, componentType }: BlogComponentProps) => {
	switch (componentType) {
		case BLOG_PAGE_TYPE.BLOG_HOME:
			return <HomeBlogPage {...data} />;
		case BLOG_PAGE_TYPE.BLOG_CATEG:
			return <CategBlogPage {...data} />;
		case BLOG_PAGE_TYPE.BLOG_TAG:
			return <TagBlogPage {...data} />;
		case BLOG_PAGE_TYPE.BLOG_ARTICLE:
			return <ArticleBlogPage {...data} />;
	}

	return <></>;
};

export default BlogComponent;
